import countries from '@assets/countries.json';
import {
  Country,
  CountryOption,
} from '@sales-portal/domain/accounts/screens/employee-list/containers/employee-invite-drawer/components/searchable-country-dropdown/searchable-country-dropdown-types';

export const DROPDOWN_WIDTH = 280;
export const MENU_ITEM_HEIGHT = 48;

export const COUNTRY_OPTIONS: CountryOption[] = (countries as Country[]).map(
  (c) => ({ ...c, key: c.code }),
);
